import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "font-weight-bold mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-6 col-md-6" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Auslösegrund")
], -1)
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "media-list" }
const _hoisted_11 = { class: "media" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mr-3" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent border-danger text-danger rounded-round border-2 btn-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-info3" })
  ])
], -1)
const _hoisted_13 = { class: "media-body align-self-center" }
const _hoisted_14 = { class: "media-heading font-weight-bold" }
const _hoisted_15 = { class: "col-6 col-md-6" }
const _hoisted_16 = { class: "card" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "ZUKOZEI Login")
], -1)
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { class: "media-list" }
const _hoisted_20 = { class: "media" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "mr-3" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "btn bg-transparent border-danger text-danger rounded-round border-2 btn-icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-info3" })
  ])
], -1)
const _hoisted_22 = { class: "media-body align-self-center" }
const _hoisted_23 = { class: "media-heading font-weight-bold" }
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-link" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { class: "media-heading font-weight-bold" }
const _hoisted_28 = { class: "col-12 col-md-6" }
const _hoisted_29 = { class: "card" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Komponente")
], -1)
const _hoisted_31 = { class: "card-body" }
const _hoisted_32 = { class: "media-list" }
const _hoisted_33 = { class: "mr-3" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "media-body align-self-center" }
const _hoisted_36 = { class: "media-heading font-weight-bold" }
const _hoisted_37 = { class: "text-muted" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = {
  key: 1,
  class: "media"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-info w-100" }, "Keine Komponenten", -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "col-12 col-md-6" }
const _hoisted_43 = { class: "card" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Kontaktiert")
], -1)
const _hoisted_45 = { class: "card-body" }
const _hoisted_46 = { class: "media-list" }
const _hoisted_47 = { class: "media" }
const _hoisted_48 = { class: "mr-3" }
const _hoisted_49 = { class: "media-body align-self-center" }
const _hoisted_50 = { class: "media-heading font-weight-bold" }
const _hoisted_51 = { class: "media" }
const _hoisted_52 = { class: "mr-3" }
const _hoisted_53 = { class: "media-body align-self-center" }
const _hoisted_54 = { class: "media-heading font-weight-bold" }
const _hoisted_55 = { class: "media" }
const _hoisted_56 = { class: "mr-3" }
const _hoisted_57 = { class: "media-body align-self-center" }
const _hoisted_58 = { class: "media-heading font-weight-bold" }
const _hoisted_59 = { class: "media" }
const _hoisted_60 = { class: "mr-3" }
const _hoisted_61 = { class: "media-body align-self-center" }
const _hoisted_62 = { class: "media-heading font-weight-bold" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-12" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "card" }
const _hoisted_67 = { class: "card-img-actions mx-1 mt-1" }
const _hoisted_68 = { class: "card-img embed-responsive embed-responsive-16by9" }
const _hoisted_69 = {
  width: "320",
  height: "240",
  controls: ""
}
const _hoisted_70 = ["src"]
const _hoisted_71 = /*#__PURE__*/_createElementVNode("source", {
  src: "movie.ogg",
  type: "video/ogg"
}, null, -1)
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")
const _hoisted_73 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body\"><div class=\"d-flex align-items-start flex-nowrap\"><div><div class=\"font-weight-semibold mr-2\">Video</div><span class=\"font-size-sm text-muted\">Size: 543kb</span></div><div class=\"list-icons list-icons-extended ml-auto\"><a href=\"#\" class=\"list-icons-item\"><i class=\"icon-download top-0\"></i></a><a href=\"#\" class=\"list-icons-item\"><i class=\"icon-bin top-0\"></i></a></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("h3", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(_ctx.alert.details?.createdAt), 1),
      _hoisted_4,
      _createElementVNode("small", null, _toDisplayString(_ctx.alert.details?.p_strasse) + " " + _toDisplayString(_ctx.alert.details?.p_hnr) + " | " + _toDisplayString(_ctx.alert.details?.p_plz) + " " + _toDisplayString(_ctx.alert.details?.p_ort), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("ul", _hoisted_10, [
              _createElementVNode("li", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.alert.reason), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("ul", _hoisted_19, [
              _createElementVNode("li", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("span", _hoisted_23, [
                    _createElementVNode("a", {
                      target: "_blank",
                      href: 'https://errichter.nsl.software/PoVi/KU/'+_ctx.alert.details?.hash
                    }, [
                      _createTextVNode("Link: https://errichter.nsl.software//PoVi/KU/" + _toDisplayString(_ctx.alert.details?.hash) + " ", 1),
                      _hoisted_25
                    ], 8, _hoisted_24)
                  ]),
                  _hoisted_26,
                  _createElementVNode("span", _hoisted_27, "PIN: " + _toDisplayString(_ctx.alert.details?.an_kunde_pin), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("ul", _hoisted_32, [
              (_ctx.alert.components?.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.alert.components, (component, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: "media"
                    }, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("img", {
                          src: '/_logos/bilderLageplan/' + component.imgKomponente,
                          class: "rounded",
                          alt: "",
                          width: "150px"
                        }, null, 8, _hoisted_34)
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, _toDisplayString(component.kurzname) + " (" + _toDisplayString(component.nummer) + ")", 1),
                        _createElementVNode("div", _hoisted_37, [
                          _createTextVNode(_toDisplayString(component.standort), 1),
                          _hoisted_38,
                          _createTextVNode(_toDisplayString(component.bemerkung), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("li", _hoisted_39, _hoisted_41))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("ul", _hoisted_46, [
              _createElementVNode("li", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["btn bg-transparent rounded-round border-2 btn-icon", _ctx.alert.contacted?.an_kunde == 1 || _ctx.alert.contacted?.email_to_kunde != ''?'border-success text-success':'border-danger text-danger'])
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.alert.contacted?.an_kunde == 1 || _ctx.alert.contacted?.email_to_kunde != ''?'icon-checkmark3':'icon-cross')
                    }, null, 2)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.alert.contacted?.an_kunde == 1 || _ctx.alert.contacted?.email_to_kunde != ''?'Kunde informiert':'Kunde nicht informiert'), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["btn bg-transparent rounded-round border-2 btn-icon", _ctx.alert.contacted?.an_polizei == 1 || _ctx.alert.contacted?.email_to_polizei != ''?'border-success text-success':'border-danger text-danger'])
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.alert.contacted?.an_polizei == 1 || _ctx.alert.contacted?.email_to_polizei != ''?'icon-checkmark3':'icon-cross')
                    }, null, 2)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.alert.contacted?.an_polizei == 1 || _ctx.alert.contacted?.email_to_polizei != ''?'Polizei informiert':'Polizei nicht informiert'), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["btn bg-transparent rounded-round border-2 btn-icon", _ctx.alert.contacted?.an_wachdienst == 1 || _ctx.alert.contacted?.email_to_wachdienst != ''?'border-success text-success':'border-danger text-danger'])
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.alert.contacted?.an_wachdienst == 1 || _ctx.alert.contacted?.email_to_wachdienst != ''?'icon-checkmark3':'icon-cross')
                    }, null, 2)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.alert.contacted?.an_wachdienst == 1 || _ctx.alert.contacted?.email_to_wachdienst != ''?'Wachdienst informiert':'Wachdienst nicht informiert'), 1)
                ])
              ]),
              _createElementVNode("li", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["btn bg-transparent rounded-round border-2 btn-icon", _ctx.alert.contacted?.an_feuerwehr == 1 || _ctx.alert.contacted?.email_to_feuerwehr != ''?'border-success text-success':'border-danger text-danger'])
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.alert.contacted?.an_feuerwehr == 1 || _ctx.alert.contacted?.email_to_feuerwehr != ''?'icon-checkmark3':'icon-cross')
                    }, null, 2)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.alert.contacted?.an_feuerwehr == 1 || _ctx.alert.contacted?.email_to_feuerwehr != ''?'Feuerwehr informiert':'Feuerwehr nicht informiert'), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_63, [
      _createElementVNode("div", _hoisted_64, [
        _createElementVNode("div", _hoisted_65, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alert.details?.videos, (video, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col-12 col-sm-6 col-md-4"
            }, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("video", _hoisted_69, [
                      _createElementVNode("source", {
                        src: video,
                        type: "video/mp4"
                      }, null, 8, _hoisted_70),
                      _hoisted_71,
                      _hoisted_72
                    ])
                  ])
                ]),
                _hoisted_73
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}